module.exports = __webpack_public_path__ + "officeBrowsing-5a32e4ff.svg";